import { CreateMasterOutletPayload, MasterOutletUpdatePayload } from '@app/api/types';
import { Address } from '@app/api/models';

import { MasterOutletFormInstance } from '../types';

const getStringValue = (value: EntityBase | string | null | undefined) => {
  if (!value) {return null;}
  if (typeof value === 'string') {return value;}
  return value.name;
};

const mapAddress = (address?: Omit<Address, 'region' | 'city'> & { region?: EntityBase; city?: EntityBase; }) => {
  if (!address) {return null;}
  const { id, region, city, ...rest } = address;
  return {
    ...rest,
    region: getStringValue(region),
    city: getStringValue(city),
    ... (id ? { id } : {}),
  };
};

export const mapInstance = (
  instance: MasterOutletFormInstance
): CreateMasterOutletPayload => {
  return {
    id: instance.id,
    parent_id: Number(instance.parent?.id),
    latlng: instance.latlng,
    unique_hash: instance.unique_hash,
    room_type_id: Number(instance.room_type?.id) || null,
    outlet_acb_id: instance.outlet_acb_id || null,
    status_id: Number(instance.status.id),
    open_date: instance.open_date,
    close_date: instance.close_date,

    name: instance.name || '',
    legal_name: instance.legal_name || '',
    title: instance.title || '',
    subnet: instance.subnet || '',
    inn: instance.inn,
    ogrn: instance.ogrn,
    legal_address: instance.legal_address || '',
    address: mapAddress(instance.address),

    kpp: instance.kpp,
    okpo: instance.okpo,
    bic: instance.bic,
    corr_account: instance.corr_account,
    account: instance.account,
    payment_deferment: instance.payment_deferment,

    director: instance.director,
    phone: instance.phone,
    email: instance.email,
    contact_person_1: instance.contact_person_1,
    contact_person_2: instance.contact_person_2,
    comment: instance.comment,

    payment_type_id: instance.payment_type ? Number(instance.payment_type.id) : undefined,
    sub_channel_id: Number(instance.sub_channel.id),
    price_id: instance.price ? Number(instance.price?.id) : undefined,
    distributor_id: instance.distributor?.id ? Number(instance.distributor.id) : undefined,
    segment_id: Number(instance.segment.id),
    division_id: Number(instance.division?.id),
    photos: instance.photos || [],

    sfa_id: instance.sfa_id,
    current_sfa_id: instance.current_sfa_id,
    dist_system_id: instance.dist_system_id,

    is_closed_for_visit: instance.is_closed_for_visit,
  };
};


export const mapUpdateInstance = (
  update_id: string,
  instance: MasterOutletFormInstance,
  process_type: string
): MasterOutletUpdatePayload => {
  return {
    id: update_id,
    outlet_id: instance.id,
    status_id: Number(instance.status.id),

    name: instance.name || '',
    title: instance.title || '',
    subnet: instance.subnet || '',
    address: instance.address ? {
      ...instance.address,
      region: instance.address.region ? instance.address.region.name : null,
      city: instance.address.city ? instance.address.city.name : null,
    } : null,

    // Заявка «Каналы» не меняет дни визита: без поля backend не трогает visits_day.
    // Иначе дни первого маршрута (из outlet/info) запишутся во все активные маршруты ТТ.
    visits_day: process_type === 'channels' ? undefined : instance.visits_day,
    route_number_id: instance.route_number ? Number(instance.route_number.id) : undefined,

    director: instance.director,
    phone: instance.phone,
    email: instance.email,
    contact_person_1: instance.contact_person_1,
    contact_person_2: instance.contact_person_2,

    sub_channel_id: process_type === 'channels' ? Number(instance.sub_channel.id) : undefined,
    distributor_id: instance.distributor?.id ? Number(instance.distributor.id) : undefined,

    is_closed_for_visit: instance.is_closed_for_visit,
    user: {
      id: instance.updater_user?.id,
      username: instance.updater_user?.username,
      full_name: instance.updater_user?.full_name,
    }
  };
};


